import React from 'react';
import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './App';
import { initializeDatabase } from '@/services/initializeDatabase';
import { initializeApp } from '@/utils/initializeApp';
import './index.css';

export const createRoot = ViteReactSSG(
  { routes, basename: import.meta.env.BASE_URL },
  async ({ isClient }) => {
    // ponytail: DB init + realtime subscriptions are client-only; skipped during SSG
    if (!isClient) return;
    try {
      await initializeDatabase();
      await initializeApp();
      await import('./utils/realtimeUpdates');
    } catch (error) {
      console.error('Client initialization failed:', error);
    }
  },
);